import React from "react";
import { Card, Col, Descriptions, Row, Space, Typography, Button } from "antd";
import { EditOutlined } from "@ant-design/icons";
import { KlearlyAPKConfig } from "../../../../interfaces/klearlyApkConfig.interface";

const { Text } = Typography;

type DepKey = keyof KlearlyAPKConfig["rapydCoreVersion"];

const LABELS: Record<DepKey, string> = {
  secureRetail: "Rapyd Core - Secure Retail",
  unitouch: "Rapyd Core - Unitouch",
};

function getLastUpdatedText(updatedOn?: Date | string) {
  if (!updatedOn) return "Last update time unknown";
  const updated = new Date(updatedOn);
  if (isNaN(updated.getTime())) return "Last update time unknown";
  const now = new Date();
  const diffMs = now.getTime() - updated.getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (days <= 0) return "Last updated today";
  if (days === 1) return "Last updated 1 day ago";
  return `Last updated ${days} days ago`;
}

export default function RapydCoreGrid({
  config,
  loading,
  onEdit,
}: {
  config?: KlearlyAPKConfig["rapydCoreVersion"];
  loading: boolean;
  onEdit: (key: DepKey) => void;
}) {
  const renderItem = (key: DepKey) => {
    const v = config?.[key];
    return (
      <Col xs={24} md={12} key={key}>
        <Card
          title={LABELS[key]}
          loading={loading}
          style={{ marginBottom: 16 }}
          extra={
            <Space size="small" align="center">
              <Text style={{ fontSize: 12 }} type="secondary">
                {getLastUpdatedText(v?.updatedOn)}
              </Text>
              <Button
                type="text"
                icon={<EditOutlined />}
                onClick={() => onEdit(key)}
              />
            </Space>
          }
        >
          {v ? (
            <Space direction="vertical" style={{ width: "100%" }} size="middle">
              <Descriptions column={1} size="small" bordered>
                <Descriptions.Item label="Name/Version">
                  {v.name}
                </Descriptions.Item>
                <Descriptions.Item label="Updated On">
                  {v.updatedOn ? new Date(v.updatedOn).toLocaleString() : "-"}
                </Descriptions.Item>
              </Descriptions>
            </Space>
          ) : (
            <Text type="secondary">No data</Text>
          )}
        </Card>
      </Col>
    );
  };

  return (
    <Row gutter={[16, 16]}>
      {(Object.keys(LABELS) as DepKey[]).map((k) => renderItem(k))}
    </Row>
  );
}
